import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import PaymentPerformanceGraph from "../../components/GastosDatos/PaymentPerformanceGraph";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function PaymentPerformance() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const user = getUser();
        const res = await fetch(`${URL}/api/activity/datos/summary/payment-performance/`, {
          headers: {
            "Content-Type": "application/json",
            "x-empresa-id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener datos");
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError("No se pudieron cargar los datos");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <Box sx={{mt:4, textAlign:'center'}}><CircularProgress /></Box>;
  if (error) return <Typography color="error" sx={{mt:4, textAlign:"center"}}>{error}</Typography>;

  return <PaymentPerformanceGraph data={data} />;
}
